import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { CardButtonBackground, CardButtonSize } from "../../components/ui-components/buttons/card-button/card-button.model";
import { FINANCIAL_DOCUMENT_ROLES, POS_ROLES, RETURN_ROLES, SALE_ROLES } from "../../guards/authorization-policy";

export const DASHBOARD_COMMON_TEMPLATE = `
<div class="dashboard__container">
  <!-- Sale transactions - for creating payment documents for tickets, trips, and vouchers -->
  <div class="dashboard__button-container" *hasRole="saleRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Normal"
      [buttonIcon]="['fas', 'cart-shopping']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToSale()">
      {{ 'webPos.saleTrans' | translate }}
    </app-card-button>
  </div>
  
  <!-- Return access is role-specific; payment methods are checked on return pages. -->
  <div class="dashboard__button-container" *hasRole="returnRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Normal"
      [buttonIcon]="['fas', 'arrow-rotate-left']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToReturn()">
      {{ ('webPos.Return' | translate) }}
    </app-card-button>
  </div>
  
  <!-- Financial documents are available to all POS roles; individual operations may be role-specific. -->
  <div class="dashboard__button-container" *hasRole="financialDocumentRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Normal"
      [buttonIcon]="['fas', 'file-invoice']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToFinancialDocuments()">
    {{ 'webPos.FinancialDocuments' | translate }}
    </app-card-button>
  </div>

  <div class="dashboard__button-container" *hasRole="posRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Normal"
      [buttonIcon]="['fas', 'calendar-check']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="openClosings()">
      {{ 'webPos.Closings.DashboardTitle' | translate }}
    </app-card-button>
  </div>
  <div class="dashboard__button-container" *hasRole="posRoles">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Normal"
      [buttonIcon]="['fas', 'chart-line']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="openReports()">
      {{ 'webPos.Reports' | translate }}
    </app-card-button>
  </div>
</div>`;

export const DASHBOARD_DEBUG_TEMPLATE = `
<div style="position: absolute; bottom: 10px; right: 100px">
  <button class="btn btn-primary" (click)="debugLogin(199001277, null, null, '509968', 509968, null, 'cashdesk.support@dertouristik.cz', 'Eva Pokorná', 'cashdesk.support@dertouristik.cz' )">
  EP 199001277
  </button>
  <button class="btn btn-primary" (click)="debugLogin(199001277, null, null, '508549', 508549, null, 'michal.sedlacek@ngretail.cz', 'Michal Sedláček', 'michal.sedlacek@ngretail.cz' )">
  MS 199001277
  </button>
  <button class="btn btn-primary" (click)="debugLogin(199001277, null, null, '571604', 571604, null, 'barbora.vajdeckova@dertouristik.cz', 'Barbora Vajdečková', 'barbora.vajdeckova@dertouristik.cz' )">
  BV 199001277
  </button>
  <button class="btn btn-primary" (click)="debugLogin(199001282)">
  TCH
  </button>
  <button class="btn btn-primary" (click)="debugLogin(199001283, '728171524')">
  TCH V
  </button>
  <button class="btn btn-primary" (click)="logout()">
  Logout
  </button>
</div>
<!-- Debug login -->`;

export abstract class DashboardComponentCommon {
  readonly CardButtonSize = CardButtonSize;
  readonly CardButtonBackground = CardButtonBackground;
  readonly saleRoles = SALE_ROLES;
  readonly posRoles = POS_ROLES;
  readonly returnRoles = RETURN_ROLES;
  readonly financialDocumentRoles = FINANCIAL_DOCUMENT_ROLES;
  protected readonly router = inject(Router);

  goToSale() {
    this.router.navigate(["sale"]);
  }

  goToReturn() {
    this.router.navigate(["return"]);
  }

  goToFinancialDocuments() {
    this.router.navigate(["financial-documents"]);
  }

  openClosings() {
    this.router.navigate(["closings"]);
  }

  openReports() {
    this.router.navigate(["reports"]);
  }
}
